export type { ColorBadgeProps } from './types';
export { default as ColorBadge } from './color-badge';
